module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'op--modal-container': true, hide: !_vm.locationInput.show
    },
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "op--modal"
  }, [_c('div', {
    staticClass: "op--modal-content"
  }, [_c('div', {
    staticClass: "card small-margin-v-s",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h3', {
    staticClass: "margin-v-z"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.typeLocation', {
    location: _vm.locType
  })))]), _vm._v(" "), _c('a', {
    staticClass: "close-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryText),
      expression: "queryText"
    }],
    ref: "RsvpEditLocationTextInput",
    staticClass: "field-text",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.queryText)
    },
    on: {
      "keyup": _vm.query,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.locationInput.isStop) ? _c('span', {
    staticClass: "remove-extra-stop",
    on: {
      "click": _vm.removeExtraStop
    }
  }, [_vm._v("[" + _vm._s(_vm.$t('rsvpEdit.removeExtraStop')) + "]")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.suggestions.length > 0),
      expression: "suggestions.length > 0"
    }],
    staticClass: "suggestions-container"
  }, [_c('div', {
    staticClass: "suggestions"
  }, _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('div', {
      key: index,
      staticClass: "suggestion",
      on: {
        "click": function($event) {
          _vm.selectLocation(index)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(suggestion.title))]), _vm._v(" "), _c('div', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(suggestion.subtitle))])])
  }))])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c060d8c8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c060d8c8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RsvpEdit/LocationInput.vue
// module id = 2137
// module chunks = 0